const {google, Vue, ga, jQuery: $} = window;
import {dealerExtendAddress} from '../../utils/dealerExtendAddress';
import {
	generateBuilderUI,
	getEnvironment,
	getCulture,
	getOptionsMatrixRegionId
} from "../_utilities";
import {
	getHash
} from "../_social-share.js";
import { ACTIONS } from "../_actions";
import { store, store$ } from "../_config-store";
import { localize, localCountries, localToggles } from "../_localize.js";

const rootURL = getEnvironment() === "DEV"
            ? "https://freightlinertrucks-dev.azurewebsites.net/umbraco/surface"
			: "/umbraco/surface";

const viewOptions$ = store$
	.map(state => state.viewOptions);
const quoteDisabled$ = store$
	.map(state => state.quoteDisabled);
/*
<template v-for="field in (thankYou ? tyFields : fields)">
*/

export const options = {
	template:
	`<form id="request-quote" @submit.prevent="" v-bind:class="{loading: loading}">
		<div v-if="dealerBrand && showBranding" dealer-brand>
			<a v-bind:href="'http://'+dealerBrand.Website" target="_blank">
				<span v-if="!dealerBrand.ConfiguratorBrandingImg">{{dealerBrand.Name}}</span>
				<img v-if="dealerBrand.ConfiguratorBrandingImg" v-bind:src="dealerBrand.ConfiguratorBrandingImg" />
			</a>
		</div>
		<template v-if="!thankYou">
			<h1 v-html="local('Request A Quote')"></h1>			
			<p v-html="local('Considering a new Freightliner truck purchase and ready for more details? You&#39;re in the right place. Request a quote here. All fields marked with an * are required.')"></p>
		</template>
		<template v-else>
			<h1>{{local('Thank You')}}, {{fields[0].value}}!</h1>
			<p v-html="local('Your quote has been submitted. Please reach out to your selected dealer below with any questions.')"></p>
			<div class="location" v-if="dealer">
				<div class="content">
					<h2 v-bind:class="{elite: dealer.EliteSupport}">{{dealer.name}}</h2>
					<a class="phone" v-bind:href="'tel:' + dealer.phone"><span class="icon-phone"></span>{{dealer.phone}}</a>
					<a class="address" v-bind:href="dealer.mapLink" target="_blank"><span class="icon-map-pin"></span><span v-html="dealer.htmlAddress"></span></a>
					<a class="website" v-bind:href="'http://' + dealer.website" target="_blank">{{dealer.website}}</a>
				</div>
				<div class="actions">
					<a class="details" role="button" v-bind:href="'/Dealer?code='+dealer.code+'&name='+encodeURIComponent(dealer.name)">View Details</a>
					<a class="directions" role="button" v-bind:href="dealer.mapLink" target="_blank">Get Directions</a>
				</div>
			</div>
		</template>
		
		
		<template v-if="!thankYou" v-for="field in fields">
			<template v-if="field.enabled === false"></template>
			<div v-else-if="field.type === 'text' || field.type === 'num8'">
				<input 
					v-bind:id="field.key" 
					v-bind:name="field.key"
					type="text"
					v-bind:placeholder="field.label + (field.required ? ' *' : '')"
					v-model="field.value"
				>
			</div>
			<div v-else-if="field.type === 'state'">
				<input
					v-bind:id="field.key"
					v-bind:name="field.key"
					type="text"
					v-bind:placeholder="field.label + (field.required ? ' *' : '')"
					v-model="field.value"
					validate="onsubmit"
					requiredtype="state"
					v-bind:invalidmessage="field.label + ' is Required'"
				>
			</div>
			<div v-else-if="field.type === 'email'">
				<input 
					v-bind:id="field.key" 
					v-bind:name="field.key"
					type="email"
					v-bind:placeholder="field.label + (field.required ? ' *' : '')"
					v-model="field.value"
				>
			</div>
			<div v-else-if="field.type === 'number'">
				<input 
					v-bind:id="field.key" 
					v-bind:name="field.key"
					type="number"
					v-bind:placeholder="field.label + (field.required ? ' *' : '')"
					v-model="field.value"
				>
			</div> 
			<div v-else-if="field.type === 'hidden'">
				<input 
					v-bind:id="field.key" 
					v-bind:name="field.key"
					type="hidden"
					v-bind:placeholder="field.label + (field.required ? ' *' : '')"
					v-model="field.value"
				>
			</div>
			
			<div v-else-if="field.type === 'tel'" type="tel">
				<input 
					v-bind:id="field.key" 
					v-bind:name="field.key"
					type="tel"
					v-bind:placeholder="field.label + (field.required ? ' *' : '')"
					v-model="field.value"
				>
				<input type="tel" placeholder="Ext." v-model="phoneExtension" id="Ext">
			</div>
			<div v-else-if="field.type === 'textarea'">
				<textarea
					v-bind:id="field.key" 
					v-bind:name="field.key"
					v-bind:placeholder="field.label + (field.required ? ' *' : '')"
					v-model="field.value"
					maxlength="500"
				></textarea>
			</div>
			<div v-else-if="field.type === 'select' && field.options.length > 0">
				<select 
					v-bind:id="field.key" 
					v-bind:name="field.key"
					v-bind:placeholder="field.label + (field.required ? ' *' : '')"
					v-model="field.value"
				>
					<option v-if="field.label" value="" disabled>{{field.label + (field.required ? ' *' : '')}}</option>
					<option v-for="option in field.options" v-bind:value="option">{{option}}</option>
				</select>
			</div>
			<div v-else-if="field.type === 'locationFromPostal'">
				<input 
					v-bind:id="field.key + 'ZipCode'" 
					v-bind:name="field.key + 'ZipCode'"
					type="text"
					v-bind:placeholder="local(field.label + ' Postal Code') + (field.required ? ' *' : '')"
					v-model="field.values['ZipCode']"
					@change="locationFromPostal(field.values)"
				>
				<select 
					v-bind:id="field.key + 'Country'" 
					v-bind:name="field.key + 'Country'"
					v-bind:placeholder="local(field.label + ' Country') + (field.required ? ' *' : '')"
					v-model="field.values['Country']"
					@change="locationFromPostal(field.values)"
				>
					<option v-if="field.label" value="" disabled>{{local(field.label + ' Country') + (field.required ? ' *' : '')}}</option>
					<option v-for="option in field.options" v-bind:value="option.code">{{option.name}}</option>
				</select>
			</div>
			<div v-else-if="field.type === 'check'">
				<input 
					type="checkbox"
					class="filled-in"
					value="true"
					v-bind:id="field.key" 
					v-bind:name="field.key"
					v-model="field.checked"
				>
				<label
					v-bind:for="field.key"
					v-html="field.label"
				></label>
			</div>
			<div v-else-if="field.type === 'checkLocation'">
				<input 
					type="checkbox"
					class="filled-in"
					value="true"
					v-bind:id="field.key" 
					v-bind:name="field.key"
					v-model="field.checked"
				>
				<label
					v-bind:for="field.key"
				>{{field.label}}</label>
				<transition name="slide" :duration="300">
					<section v-show="field.checked">
						<template v-if="mailingVerify">
							<div specific v-show="!international">
								<input address-location :placeholder="local('Mailing Address') + ' *'" type="text">
							</div>
							<template v-if="mailingAddress">
								<div v-if="!(mailingAddress.street_number && mailingAddress.route)" class="errors">
									<p v-html="local('Please enter a more specific mailing address.')"></p>
								</div>
								<div v-else-if="international">
									<h6 v-html="local('Please make sure this address is correct:')"></h6>
									<textarea v-model="international" :placeholder="local('Enter your international address')" auto-focus></textarea>
								</div>
								<div v-else>
									<input type="text" :placeholder="local('Apartment / Suite (optional)')" v-model="address2">
								</div>
							</template>
						</template>
						<div v-else>
							<h6 v-html="local('Please make sure this address is correct:')"></h6>
							<textarea v-model="international" :placeholder="local('Enter your international address')" auto-focus></textarea>
						</div>
					</section>
				</transition>
			</div>
			<div v-else-if="field.type === 'dealer'" class="dealer">
				<header @click="expandDealer" v-bind:class="dealerExpanded ? 'expanded' : ''">{{!dealer ? field.label + (field.required ? ' *' : '') : local('My Dealer') + ': ' + dealer.Name}}</header>
				<transition name="slide" :duration="300">
					<section v-show="dealerExpanded">
						<div region v-if="false">
							<label>{{local('Search in')}}</label>
							<select>
								<option>{{local('US & Canada')}}</option>
								<option>{{local('Global Dealer Locations')}}</option>
							</select>
						</div>
						<div specific v-if="dealerSearch">
							<input location :placeholder="local('City or Address')" id="Address">
							<span use-location @click.stop="useLocation"></span>
						</div>
						<div v-if="locationError">{{locationError}}</div>
						<div v-if="dealers.length > 0 && !dealersLoading">
							<h6>{{dealers.length}} {{dealerSearch ? 'nearest Results' : local('Dealers')}}</h6>
							<ul>
								<li v-for="dlr in dealers" @click="selectDealer(dlr,field)" v-bind:class="dealer === dlr ? 'selected' : ''">
									<label name>{{dlr.Name}}</label>
									<label address v-if="dlr.City && dlr.State">{{dlr.City}}, {{dlr.State}}</label>
									<label distance v-if="dealerSearch">{{getDistance(dlr.Latitude,dlr.Longitude) + ' ' + local('Miles Away')}}</label>
								</li>
							</ul>
						</div>
						<div v-if="dealersLoading" loading v-html="local('Checking for dealers near you...')"></div>
					</section>
				</transition>
			</div>
		</template>
		<div class="errors" v-if="errors.length > 0">
			<p v-for="error in errors">{{error}} {{local('Required')}}</p>
		</div>
		<footer v-if="!thankYou">
			<button type="button" @click="quoteSubmit" :disabled="quoteDisabled">{{local('REQUEST QUOTE')}} {{loading ? '('+local('Loading')+'...)' : ''}}</button>
			<span class="note" v-show="quoteDisabled" v-html="local('Hang on while we update your truck...')"></span>
		</footer>
		<footer v-else-if="false">
			<button type="button" @click="thankSubmit">{{local('SUBMIT')}} {{loading ? '('+local('Loading')+'...)' : ''}}</button>
		</footer>
	</form>`,
	data() {		
		return {
			showBranding: false,
			location: undefined,
			mailingVerify: ['es-co'].indexOf(getCulture()) === -1,
			locationError: '',
			dealerExpanded: !window.dealers || window.dealers.length > 1 ? true : false,
			dealers: window.dealers || [],
			dealerSearch: !window.dealers,
			dealer: !window.dealers || window.dealers.length > 1 ? undefined : window.dealers[0],
			errors: [],
			thankYou: false,
			mailingAddress: undefined,
			address2: undefined,
			international: undefined,
			phoneExtension: '',
			local(str){
				return str;
			},
			fields: [],
			loading: false,
			dealersLoading: false,
			referrer: window.referrer ? window.referrer : ''
		}
	},
	subscriptions() {
		return {
			viewOptions: viewOptions$,
			quoteDisabled: quoteDisabled$,
			store: store$
		}
	},
	computed: {
		dealerBrand(){
			return (window.dealers || [])[0];
		}
	},
	methods: {
		availableOptions: function(view) {
			return generateBuilderUI(this.store,view);
		},
		useLocation(){
			let input = $(this.$el).find('input[location]');
			fillGeo(input).done( latlng => {
				this.locationError = '';
				this.location = {
					latitude: latlng.lat,
					longitude: latlng.lng
				};
			}).fail( () => {
				this.locationError = this.local('We were unable to get your location.');
				this.location = undefined;
			});
		},
		getDistance(lat1,lon1) {
			let lat2 = this.location.latitude,
				lon2 = this.location.longitude,
				R = 6371, // Radius of the earth in km
				dLat = deg2rad(lat2-lat1),  // deg2rad below
				dLon = deg2rad(lon2-lon1),
				a =
					Math.sin(dLat/2) * Math.sin(dLat/2) +
					Math.cos(deg2rad(lat1)) * Math.cos(deg2rad(lat2)) *
					Math.sin(dLon/2) * Math.sin(dLon/2),
				c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1-a)),
				d = R * c; // Distance in km
			return Math.round(d * 0.621371); // Return miles
		},
		locationFromPostal(values){
			let {ZipCode,Country} = values;
			return Country && ZipCode ? 
				(new google.maps.Geocoder()).geocode( {componentRestrictions:{ country:Country, postalCode:ZipCode }}, (results, status) => {
					if(status === 'OK'){
						let [{address_components}] = results,
							city = (address_components.find( ({types}) => types.indexOf('locality') !== -1) || {}).short_name,
							state = (address_components.find( ({types}) => types.indexOf('administrative_area_level_1') !== -1) || {}).short_name;
						values.City = city;
						values.State = state;
					}
				}) : false;

		},
		quoteSubmit(){
			this.errors = _.chain(this.fields.concat( (this.fields.find(item => item.key === "Mail") || {}).checked? [
				{ label: this.local('Mailing Address'), required: true, value: !this.mailingVerify || (this.mailingAddress && this.mailingAddress.street_number && this.mailingAddress.route) ? 'address' : '' },
			] : [] ).concat([
				{ label: this.local('Select My Dealer'), required: true, value: this.dealer ? 'selected' : false },
			])).map( item => {
				let checks = {
					email: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
					num8: /^\d{8}$/,
					locationFromPostal: {
						test({ZipCode,Country}){
							console.log('location Test',{ZipCode,Country});
							return ZipCode && Country;
						}
					}
				};

				if ((item.required || !!item.value) && item.type === 'locationFromPostal') {
					return checks.locationFromPostal.test(item.values) ? undefined : this.local(item.label + ' Postal Code and Country');
				}
				return (item.required || !!item.value)
					&& (!(typeof item.value === 'string' ? item.value : '').trim()
						|| (checks[item.type]
							&& !checks[item.type].test(item.value))) ? item.label : undefined;
			}).compact().value();


			// console.log('mailingAddress', this.mailingAddress);

			if(this.errors.length === 0 && !this.loading){
				this.loading = true;
				getHash().done( (hash) => {
					//console.log('HASH CREATED',hash);
					console.log('rootUrl', rootURL);
					$.ajax({
						url: rootURL + '/forms/RequestQuoteConfigurator', // $.tb.rootURL
						method: "POST",
						data: Object.assign(
							{
								Configuration: JSON.stringify(_.fromPairs(this.viewOptions.reduce( (arr, optionGroup) => {
									return arr.concat(this.availableOptions(optionGroup.name).reduce( (groupList, option) => {
										if(option.children && option.children.length){
											option.children.forEach( (child) => {
												if(child.current){
													groupList.push([optionGroup.name+'|'+child.component, child.current]);
												}
											});
										}
										else if(_.at(option,'options[0].current')[0]){
											option.options.forEach((child) => {
												groupList.push([optionGroup.name+'|'+child.label, child.current]);
											});
										}
										else {
											groupList.push([optionGroup.name + '|' + option.label, option.current]);
										}
										return groupList;
									},[]));
								},[]))),
								RequestTypes: this.fields.reduce( (arr, field) => {
									if(['check','checkLocation'].indexOf(field.type) !== -1 && field.checked){
										arr.push(field.key);
									}
									return arr;
								}, [] ),
								UTM: location.search,
								IsInternal: window.self === window.top,
								Address: this.joinedAttributes(['mailingAddress.street_number','mailingAddress.route'],' '),
								Address2: this.joinedAttributes(['address2']),
								City: this.joinedAttributes(['mailingAddress.locality']),
								State: this.joinedAttributes(['mailingAddress.administrative_area_level_1']),
								Country: this.joinedAttributes(['mailingAddress.country']),
								PostalCode: this.joinedAttributes(['mailingAddress.postal_code','mailingAddress.postal_code_suffix'],'-'),
								InternationalAddress: this.joinedAttributes(['international']),
								CabType: this.store.truckCab,
								Model: this.store.truckModel,
								Referrer: this.referrer,
								OptionsMatrixId: getOptionsMatrixRegionId(),
								TruckHash: hash,
								PhoneExtension: this.phoneExtension,
								ClientId: ga && ga.getAll ? ga.getAll()[0].get('clientId') : 'notfound',
								Dealer: _.pick(this.dealer,[
									'Address',
									'City',
									'Email',
									'Name',
									'Phone',
									'Zip',
									'State',
									'IsInternational'
								])
							},
							this.fields.reduce( (obj, field) => {
								if(['check'].indexOf(field.type) === -1){
									if(field.values){
										Object.keys(field.values).forEach(key => {
											obj[field.key + key] = field.values[key];
										});
									}
									else {
										obj[field.key] = field.value;
									}
								}
								return obj;
							}, {} )
						)
					}).done( () => {
						let $configurator = $("#configurator");
						// Show thank you
						this.thankYou = true;
						this.loading = false;
						$configurator.animate({ scrollTop: $('#request-quote').offset().top + $configurator.scrollTop() });

						store.dispatch({
							type: ACTIONS.QUOTE_SUBMITTED,
							hash: hash,
							dealer: Object.assign({}, this.dealer),
							application: _.find(this.fields,{ key: 'Applications'}).value
						});

					}).fail( () => {
						this.loading = false;
					});
				}).fail( () => {
					this.loading = false;
				});

			}
			// console.log(this.fields);
		},
		joinedAttributes(paths,glue = ''){
			return _.compact(paths.reduce( (list, path) => {
				return list.concat(_.at(this,path));
			}, [])).join(glue);
		},
		thankSubmit() {
			this.errors = _.chain(this.tyFields).map( item => {
				return item.required && !item.value ? item.label : undefined;
			}).compact().value();
		},
		expandDealer(){
			this.dealerExpanded = !this.dealerExpanded;
		},

		selectDealer(dealer,field){
			this.dealer = dealerExtendAddress(dealer);
			this.dealerExpanded = false;
			field.value = dealer.Code;
		}
	},
	watch: {
		location() {
			if(this.location){
                this.dealersLoading = true;
				let apiAddress = (window.apiAddress)
					? window.apiAddress
					: rootURL + '/dealers/GetByDistance';
				$.ajax({
					url: apiAddress,
					method: "POST",
					data: Object.assign({},this.location,{
						count: 10,
						radius: 1000,
						type: 'FTLSALES',					
						countries: localCountries(true).map(({code}) => code.toLowerCase()).join(',')
					})
				}).done(dealers => {						
					this.dealers = filterDealers(window.truckModel || "P4", dealers);
				}).fail( () => {

				}).always( () => {
					this.dealersLoading = false;
				});
			}
			else {
				this.dealersLoading = false;
				this.dealers = [];
			}
		},
		local(local) {
			this.fields = [
				{ key: 'FirstName', label: local('First Name'), type: 'text', required: true, value:'' },
				{ key: 'LastName', label: local('Last Name'), type: 'text', required: true, value:'' },
				{ key: 'Email', label: local('Email'), type: 'email', required: true, value:'' },
				{ key: 'Company', label: local('Company or Business Name'), type: 'text', required: true, value:'' },
				{ key: 'CompanyWebsite', label: local('Company Website'), type: 'text', required: false, value:'' },
				{ key: 'Business', label: 'Business', type: 'locationFromPostal', required: true, values: {ZipCode:'',Country:'',City:'',State:''}, options: localCountries() },
				{ key: 'Phone', label: local('Phone'), type: 'tel', required: true, value:'' },
                { key: 'Applications', label: local('How will you use your truck?'), type: 'select', required: true, options: _.compact((window.applications || '').split(',')).map( str => local(str)), value: '' },
				{ key: 'PurchasePlan', label: local('When do you plan to purchase?'), type: 'select', required: true, options: [local(`Now`), local(`1-3 Months`), local(`4-6 months`), local(`6+ months`)], value: '' },
				{ key: 'DealerCode', label: local('Select My Dealer'), type: 'dealer', required: false, value: !window.dealers || window.dealers.length > 1 ? '' : window.dealers[0].Code },
				{ key: 'Comments', label: local('Comments'), type: 'textarea', value:'' },
				{ key: 'MCUSDOT', label: local('USDOT/MC Number (8 Digit)!'), type: 'num8', required: false, value: '', enabled: localToggles('MCUSDOT') },
				{ key: 'OptIn', label:'I agree that Daimler Truck North America and its partners may send me promotional email messages with offers, updates and other marketing messages. I understand and agree that Daimler Truck North America and its partners may use my information in accordance with its <a href="https://northamerica.daimlertruck.com//privacy-policy" target="_blank">Privacy Policy</a>.', type:'check', required:false, checked: false}
			];
		}
	},
	mounted() {
		// Attach third party functionality
		let $container = $(this.$el);

		setTimeout(()=>{
			if($container.find('input[location]')[0]){
				let autocompleteLocation = new google.maps.places.Autocomplete($container.find('input[location]')[0],{types: ['geocode']});
				//console.log('AUTOCOMPLETE',autocompleteLocation);
				// When the user selects an address from the dropdown, populate the address
				// fields in the form.
				autocompleteLocation.addListener('place_changed', () => {
					let place = autocompleteLocation.getPlace(),
						loc = place.geometry.location;
					// console.log(place,place.geometry.location.lat());
					this.locationError = '';
					this.location = {
						latitude: loc.lat(),
						longitude: loc.lng()
					};
				});
			}
			if($container.find('input[address-location]')[0]){

				let autocompleteAddress = new google.maps.places.Autocomplete($container.find('input[address-location]')[0],{types: ['geocode']});

				// When the user selects an address from the dropdown, populate the address
				// fields in the form.
				autocompleteAddress.addListener('place_changed', () => {
					let place = autocompleteAddress.getPlace();
					this.mailingAddress = _.chain(place.address_components).map( item => [item.types[0],item.long_name] ).fromPairs().value();
					if(['United States','Canada'].indexOf(this.mailingAddress.country) === -1 && this.mailingAddress.street_number && this.mailingAddress.route){
						this.international = place.formatted_address;
					}

					//console.log(place,this.mailingAddress);
				});

			}
		},500);

		// focus handler for GTM logging of form completion
		$container.on("focusin", e => {
			if (window.dataLayer && e.target.id) {
				window.dataLayer.push({
					event: "configurator_request_quote_form",
					data: {
						configuratorRequestQuote: {
							fieldId: e.target.id
						}
					}
				});
			}
		});
	},
	created() {
		localize().then( local => this.local = local );
	}
}

function filterDealers(selectedTruck, dealers) {

	function M2Filter(apiDealers) {
		return apiDealers.filter(
			dealer => dealer.IsInternational
				|| dealer.SlsSvcProdDescList.concat(dealer.SlsOnlyProdDescList).findIndex(x => x.toLowerCase().indexOf('m2') > -1) > -1
		);
	}

	function P4Filter(apiDealers) {		
		let arr = [];
		apiDealers.forEach(function (x) {
			if (x.IsInternational) {
				arr.push(x);
			} else {
				var lowerCaseTrucks = x.SlsSvcProdDescList
					.concat(x.SlsOnlyProdDescList)
					.map(function (a) { return a.toLowerCase(); });
				if (lowerCaseTrucks.indexOf('cascadia') !== -1) {
					arr.push(x);
				}
			}
		});
		return arr;
	}

	function NoFilter(apiDealers) {
		return apiDealers;
	}

	function GetFilter(truck) {
		if (truck.indexOf('cascadia') > -1 || truck.indexOf('p4') > 0) {
			return P4Filter;
		} else if (truck.indexOf('m2') > -1) {
			return M2Filter;
		} else {
			return NoFilter;
		}
	}

	let filter = GetFilter.call(this, selectedTruck ? selectedTruck.toLowerCase() : 'p4');	
	return filter(dealers);

}

function fillGeo(el){
	var deferred = $.Deferred();
	//var current = el.val();
	function cancel(){
		$(this).removeClass('loading-location').off('click',cancel);
	}
	if(el.parent().hasClass('loading-location')){
		return deferred;
	}
	el.parent().addClass('loading-location').removeClass('fallback').on('click',cancel);
	navigator.geolocation.getCurrentPosition(function(position) {

		if(!el.parent().hasClass('loading-location')){
			return;
		}
		var latlng = {lat: position.coords.latitude, lng: position.coords.longitude},
			geo = new google.maps.Geocoder();
		geo.geocode({'location': latlng}, function(results, status) {
			if(!el.parent().hasClass('loading-location')){
				return;
			}
			if (status === google.maps.GeocoderStatus.OK) {
				if (results[0]) {
					el.val(results[0].formatted_address);
					deferred.resolve(latlng);
				} else {
					deferred.reject();
					console.info('No results found');
				}
			} else {

				deferred.reject();
				console.info('Geocoder failed due to: ' + status);
			}
			el.parent().removeClass('fallback').removeClass('loading-location').off('click',cancel);
			// if(el.val() === ''){
			// 	el.val(current);
			// }
		});
	},function(PosError){
		console.log(PosError);
		//alert('There was an error loading your location. Please search by city, state or zip.');

		geoFallback(el).done(latlng => {
			deferred.resolve(latlng);
		}).fail( () => {
			deferred.reject();
		});

		el.parent().addClass('fallback').off('click',cancel);
	},{enableHighAccuracy: true, maximumAge: 10000, timeout: navigator.userAgent.toLowerCase().indexOf("android") > -1 ? '15000' : '5000'});
	return deferred;
}

function deg2rad(deg) {
	return deg * (Math.PI/180)
}

function geoFallback(el){
	var deferred = $.Deferred();
	if(el.parent().hasClass('loading-location') || el.val() === ''){
		$.ajax({
			url: 'https://api.ipstack.com/check?access_key=7652d0f71a5071a6044703dc68df0d05&output=json&legacy=1',
			dataType: 'json',
			localCache: true
		}).done(function(data){
			el.parent().removeClass('loading-location');
			if(data.city && data.region_code){
				el.val(data.city + ', ' + data.region_code);
				deferred.resolve({lat: data.latitude, lng: data.longitude});
			}
			else {
				deferred.reject();
			}
		});
	}
	return deferred;
}

Vue.component('request-quote',options);